import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d793e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sku-detail-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-col-title" }, "价格", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-col-title" }, "库存", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-col-title" }, "重量", -1))
const _hoisted_5 = {
  key: 0,
  class: "sku-item-box"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "批量设置：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: _ctx.modelValue,
      "span-method": _ctx.arraySpanMethod,
      border: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computSku, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            label: item.name
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(item.specList[row.indexList[index]].name), 1)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "价格"
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_ui_input, {
              modelValue: row.price,
              "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
              validate: "decimal"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "stock",
          label: "库存"
        }, {
          header: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_ui_input, {
              modelValue: row.stock,
              "onUpdate:modelValue": ($event: any) => ((row.stock) = $event),
              validate: "int"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "weight",
          label: "重量"
        }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(({ row }) => [
            _createVNode(_component_ui_input, {
              modelValue: row.weight,
              "onUpdate:modelValue": ($event: any) => ((row.weight) = $event),
              validate: "decimal"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "span-method"]),
    (_ctx.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _createVNode(_component_el_link, {
              underline: false,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setValue('price'))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("价格")
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              underline: false,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setValue('stock'))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("库存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              underline: false,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setValue('weight'))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("重量")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}